import React, { useEffect, useRef, useState } from "react";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import { getForexOrderById } from "../../../services/ForexOrderService";

const ViewForexOrder = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (id && !hasFetched.current) {
      hasFetched.current = true;
      const fetchOrder = async () => {
        try {
          const response = await getForexOrderById(id);
          setOrder(response.data.data);
        } catch (error) {
          console.error("Error fetching forex order:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchOrder();
    }
  }, [id]);

  if (loading) {
    return (
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="text-center mt-5">
        <p>Forex Order not found.</p>
        <button className="btn btn-primary" onClick={() => navigate(-1, {
          state: {
            page: location.state?.page || 1,
            searchTerm: location.state?.searchTerm || "",
          },
        })}>
          Go Back
        </button>
      </div>
    );
  }

  return (
    <>
      <PageTitle
        activeMenu="View Forex Order"
        motherMenu="Forex Orders"
        activeMenuLink={`view-order/${id}`}
        motherMenuLink={"order"}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div
                  className="d-flex align-items-center gap-2 cursor-pointer"
                  onClick={() => {
                    navigate("/order", {
                      state: {
                        page: location.state?.page || 1,
                        searchTerm: location.state?.searchTerm || "",
                      },
                    })
                  }}
                >
                  <i className="fas fa-chevron-left"></i>
                  <span>Forex order List</span>
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label fw-bold">User</label>
                <p className="form-control-plaintext">{order.user_name}</p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Sending Amount</label>
                <p className="form-control-plaintext">{order.sending_amount}</p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Receiving Amount</label>
                <p className="form-control-plaintext">
                  {order.receving_amount}
                </p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Rate</label>
                <p className="form-control-plaintext">{order.rate}</p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Amount</label>
                <p className="form-control-plaintext">{order.total_amount}</p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Forex Service</label>
                <p className="form-control-plaintext">
                  {order.forex_service_name}
                </p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Currency From</label>
                <p className="form-control-plaintext">{order.from_currency}</p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Currency To</label>
                <p className="form-control-plaintext">{order.to_currency}</p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Address</label>
                <p className="form-control-plaintext">{order.address}</p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Status</label>
                <p className="form-control-plaintext text-capitalize">
                  {order.status}
                </p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Created On</label>
                <p className="form-control-plaintext">
                  {new Date(order.createdAt).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewForexOrder;
